// File: src/App.tsx
import React, { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Sequencer from './components/Sequencer';
import MenuBar from './components/MenuBar';
import Visualizer from './components/Visualizer';
import './styles/tailwind.css';
import './styles/global.css';
function App() {
    const [visualizerMode, setVisualizerMode] = useState('waveform');
    return (React.createElement(Router, null,
        React.createElement("div", { className: "w-full h-screen flex flex-col" },
            React.createElement(MenuBar, { visualizerMode: visualizerMode, setVisualizerMode: setVisualizerMode }),
            React.createElement("div", { className: "flex flex-grow overflow-hidden" },
                React.createElement("div", { className: "flex-1 flex flex-col bg-gray-900 p-4" },
                    React.createElement(Sequencer, null)),
                React.createElement("div", { className: "w-1/2 border-l border-gray-700 pl-2" },
                    React.createElement(Visualizer, { mode: visualizerMode }))))));
}
export default App;
